import { defineComponent } from 'vue';
import { Form, FormItem, Input, Button } from 'ant-design-vue';
import { PhoneOutlined } from '@ant-design/icons-vue';
import * as api from '@src/api/auth';
import type { LoginData } from '@src/api/auth';
import { useSendCode } from '../hooks/useSendCode';
import { useStoreLoginModal } from '@src/store/modules/loginModal';

export default defineComponent({
    name: 'MessageCode',
    emits: ['setKey'],
    setup(props, context) {
        const storeLoginModal = useStoreLoginModal();

        /**
         * data
         */
        const { sendCode, disabled: sendDisabled, loading: sendLoading, text: sendText, uuid: sendUuid } = useSendCode();

        const formLoading = ref(false);
        const formState = reactive({
            loginName: '',
            code: '',
        }) as Omit<LoginData, 'uuid' | 'password'>;
        const formRef = ref();

        /**
         * methods
         */
        const phoneValidator = async (_rule: any, value: string) => {
            if (!value) {
                return Promise.reject('请输入手机号');
            } else if (!/^[1][3-9][0-9]{9}$/.test(value)) {
                return Promise.reject('请输入正确手机号');
            } else {
                return Promise.resolve();
            }
        };

        const handleSend = async () => {
            await formRef.value.validate(['loginName']);
            sendCode({ phone: formState.loginName });
        };
        const handleSubmit = async () => {
            await formRef.value.validate();
            formLoading.value = true;
            const res = await api
                .phoneLogin({
                    uuid: sendUuid.value,
                    ...formState,
                })
                .finally(() => {
                    formLoading.value = false;
                });
            await storeLoginModal.handleLoginSuccess((res as any).token);
        };

        return () => (
            <Form model={formState} ref={formRef}>
                <FormItem name='loginName' rules={[{ required: true, validator: phoneValidator, trigger: 'blur' }]}>
                    <Input
                        v-model:value={formState.loginName}
                        placeholder='请输入手机号'
                        autocomplete='off'
                        v-slots={{ prefix: () => <PhoneOutlined /> }}
                    />
                </FormItem>
                <div class='phone-code g-flex'>
                    <FormItem class='g-flex-1' name='code' rules={[{ required: true, message: '请输入验证码', trigger: 'blur' }]}>
                        <Input v-model:value={formState.code} onPressEnter={handleSubmit} placeholder='请输入验证码' autocomplete='off' />
                    </FormItem>
                    <Button
                        type='primary'
                        class='g-ml-[14px] g-h-[44px] g-w-[105px] g-flex-shrink-0 g-rounded-[10px] g-font-size-[14px]'
                        loading={sendLoading.value}
                        disabled={sendDisabled.value}
                        onClick={handleSend}
                    >
                        {sendText.value}
                    </Button>
                </div>
                <div
                    class='g-mb-[18px] g-cursor-pointer g-text-align-right g-font-size-[14px] g-color-[#757575] g-line-height-[12px]'
                    onClick={() => {
                        context.emit('setKey', '手机号注册');
                    }}
                >
                    <span>手机号注册</span>
                </div>
                <Button
                    type='primary'
                    class='g-h-[44px] g-w-full g-rounded-[22px] g-p-[0] g-font-size-[15px]'
                    onClick={handleSubmit}
                    loading={formLoading.value}
                >
                    登录
                </Button>
            </Form>
        );
    },
});
